import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import Formatter from '../../Utilities/Formatter';

class SalesCard extends Component {
    constructor(props) {
        super(props);
        this.formatter = new Formatter();

    }



    render() {
        return (
            <div>

                <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                    <MDBCardTitle style={{ fontSize: "16px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{this.props.demName}{this.props.sales > this.props.prevSegmentSales ? (<div style={{ fontSize: "20px" }} className="float-right"><MDBIcon far icon="arrow-alt-circle-up" style={{ color: "green" }} /></div>) : (<div style={{fontSize:"20px"}} className="float-right"><MDBIcon far icon="arrow-alt-circle-down" style={{ color: "red" }} /></div>)}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="phone" />&nbsp;&nbsp;{this.props.telephoneCell}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Code:&nbsp;{this.props.demCode}</MDBCardTitle>
                    <hr />
                    <MDBCardText>
                        <MDBRow>
                            <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                <span style={{ fontSize: "14px" }}>Sales This Seg</span><br /> <strong>{this.formatter.formatCurrency(this.props.sales)}</strong>
                            </MDBCol>
                            <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                <span style={{ fontSize: "14px" }}>Sales Prev Seg</span><br /> <strong>{this.formatter.formatCurrency(this.props.prevSegmentSales)}</strong>
                            </MDBCol>
                        </MDBRow>
                    </MDBCardText>
                    <hr />
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Unit:&nbsp;{this.props.unitName}</MDBCardTitle>
                </MDBCard>

            </div>
        )
    }
}

export default SalesCard;